import Dexie, { Table } from 'dexie';
import { Product, ProductVariant } from '../types';

export interface CachedProduct extends Product {
    variants: ProductVariant[];
    _cachedAt: number;
}

export interface CacheMetadata {
    key: string;
    lastFetchedAt: number;
    totalCount: number;
}

class ProductDatabase extends Dexie {
    products!: Table<CachedProduct, number>;
    metadata!: Table<CacheMetadata, string>;

    constructor() {
        super('RuyoMarketDB');
        this.version(1).stores({
            products: 'id, status, created_at, _cachedAt, updated_at',
            metadata: 'key',
        });
    }
}

export const db = new ProductDatabase();

export const productCache = {
    // Получить все продукты (с фильтрами из кэша)
    async getAll(): Promise<CachedProduct[]> {
        return db.products.toArray();
    },

    // Upsert — сохранить или обновить
    async upsertMany(products: CachedProduct[]): Promise<void> {
        await db.products.bulkPut(products);
    },

    // Удалить продукты которых больше нет
    async deleteMany(ids: number[]): Promise<void> {
        await db.products.bulkDelete(ids);
    },

    // Очистить всё
    async clear(): Promise<void> {
        await db.products.clear();
    },

    // Метаданные последней синхронизации
    async getMetadata(key: string): Promise<CacheMetadata | undefined> {
        return db.metadata.get(key);
    },

    async setMetadata(meta: CacheMetadata): Promise<void> {
        await db.metadata.put(meta);
    },
};